export const BRAND_DELETE_OPEN_MODAL = "BRAND_DELETE_OPEN_MODAL";
export const BRAND_DELETE_REQUEST = "BRAND_DELETE_REQUEST";
export const BRAND_DELETE_RESULT = "BRAND_DELETE_RESULT";